if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

$(document).on("click", function(event){
    var $drawerWrapper = $('.drawer-wrapper');

    if(!$(event.target).closest(".drawer-main").length){
      if($drawerWrapper.hasClass('open')){
        CartObj.closeDrawer();
      }
    }
});

$(document).on('click', '.gift-msg-trigger', function(e){
  $('.cart-note-container').slideToggle(400);
  });

/*

$(document).on('click', '.site-header__cart', function(e){
  e.preventDefault();
  CartObj.openDrawer();
});

*/

$(document).on('click', '.drawer-close', function(e){
  CartObj.closeDrawer();
});

$(document).on('click', '#AddToCart-product-template, #AddToCart-product-template-gift, .product-form__item button[name="add"]:not(.checkout)', function(e) {  
  e.preventDefault();
  var quantity = $(this).closest('form').find('.quantity__input').val(),
    productID = $(this).closest('.product__submit').data('product-id'),
    collectionID = $(this).data('collection'),
    form = $(this).closest('form'),
    form_array = form.serializeArray();
  if (form.find('[type="file"]').length){
    return;
  }
  var form_data = {};
  $.map(form_array, function(val, i){
    form_data[val.name] = val.value;
  });
  
  console.log(form_data);
  CartObj.addToCart(form_data);
  
});

$(document).on('change', '.quantity__input', function(e){
  e.preventDefault();
  var $this = $(this);
  var qty = $(this).val();
  var key = $this.parents('.cart-item').data('id');
  
  ChangeQty(key,qty, $this);
});

$(document).on('click', '.drawer-qty-adjust', function(e){
  e.preventDefault();
  var $this = $(this);
  var qty = $(this).siblings('input').val();
  var key = $this.parents('.cart-item').data('id');
  
  ChangeQty(key,qty, $this);
  
});

$(document).on('click', 'a.cart-item-remove-container', function(e){
  e.preventDefault();
  var uid = $(this).data('monogram');
  var keys = {};
  
  if($(this).hasClass('monogram-remove')){
    $('[data-monogram="' + uid + '"]').each(function(){
      var key = $(this).data('key');
      keys[key] = 0;
    });
  }else{
    var key = $(this).data('key');
    keys[key] = 0;
  }

  console.log(keys);

  var params = { updates: keys };

  console.log(params);

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    dataType: 'json',
    data: params,
    success: function(data){
      //console.log(data);
      CartObj.cartReloadPageRefresh();
    },
    error: function(){}
  });
});


$(document).ready(function(){ 

  var $drawer_recommendation_slider = $('.js-drawer-recommendation-slider')
  var $drawer_arrows_container = $('.drawer-recommendation-slideshow-controls .slideshow__arrows');

  $drawer_recommendation_slider.slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: $drawer_arrows_container
  })

  

  $drawer_arrows_container.find('.slideshow__arrow-left').on('click', function(e) {
    e.preventDefault();
    $drawer_recommendation_slider.slick('slickPrev');
  });
  $drawer_arrows_container.find('.slideshow__arrow-right').on('click', function(e) {
    e.preventDefault();
    $drawer_recommendation_slider.slick('slickNext');
  });


   var $drawer_swatch_carousel = $('.js-drawer-swatch-carousel');

   $drawer_swatch_carousel.slick({
      dots: false,
      infinite: false,
      autoplay: false,
      speed: 300,
      slidesToShow: 3,
       draggable:false,
      slidesToScroll: 1,
      prevArrow:'<button type="button" class="slick-arrow slick-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><path d="M30.83 14.83l-2.83-2.83-12 12 12 12 2.83-2.83-9.17-9.17z"/><path d="M0 0h48v48h-48z" fill="none"/></svg></button>',
      nextArrow:'<button type="button" class="slick-arrow slick-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><path d="M20 12l-2.83 2.83 9.17 9.17-9.17 9.17 2.83 2.83 12-12z"/><path d="M0 0h48v48h-48z" fill="none"/></svg></button>'
    })

  $('.drawer-recommendation-item-swatch label').click(function(e){
    $(this).siblings('input[type="radio"]').prop("checked", true).trigger('click');
    
  })

  $('.drawer-recommendation-item-swatch input[type="radio"]').click(function(e){
    var value = $(this).val();
    var $container = $(this).parents('.drawer-recommendation-item');
    var $selected_option = $container.find('.drawer-recommendation-item-id').find('option[value="' + value + '"]');
    var $atc_button = $container.find('.js-drawer-recommendation-atc');
    var $image_container = $container.find('.drawer-recommendation-item-image');
    var image_url = $selected_option.data('image');
    var variant_id = $selected_option.data('variant');
    $atc_button.data('id', variant_id);
    $image_container.attr('src', image_url);
  })

  $('.js-drawer-recommendation-atc').click(function(e){
    e.preventDefault();
    var $this = $(this);
    
    var variant_id = $this.data('id');
    var quantity = 1;

    if($this.hasClass('cart-recommendation-atc')){
      
      let params = {
        items: [
          {
            quantity: quantity,
            id:variant_id,
          }
        ]
      }

      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function(data){
  		location.reload();
        },
        error: function(){}
      });
    }else{
      
      let form_data = {
        quantity: quantity,
        id: variant_id 
      }
    
      CartObj.addToCart(form_data);
    }

    
    
    $this.prop('disabled', true);
    $this.text('Added to cart...')

    setTimeout(function(){
      $this.prop('disabled', false);
      $this.text('ADD PRODUCT')
    }, 5000)
  })
  
  CartObj.rebuildSuggested();
})

$(document).on('click', '#drawer-checkout-btn', function(e){
  console.log('checkout');
  e.preventDefault();
  var gift_to = $('#to').val();
  var gift_from = $('#from').val();
  var gift_message = $('#giftmessage').val();
  if(gift_to != "" || gift_from != "" || gift_message != ""){
    var params = {
                  attributes: {
                    'To': gift_to,
                    'From': gift_from,
                    'giftmessage': gift_message,
                  }
                 }

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      dataType: 'json',
      data: params,
      success: function(cart){
        console.log(cart);
        location.href = "/checkout";
      },
      error: function(e){
        console.log(e);
      }
    });
  }else{
    location.href = "/checkout";
  }
});

function ChangeQty(key, qty, $el){
  if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
    qty = parseInt(qty);
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  if(!$el.hasClass('quantity__input')){
      // Add or subtract from the current quantity
    if ($el.hasClass('quantity__plus')) {
      qty = qty + 1;
    } else {
      qty = qty - 1;
      if (qty <= 1) qty = 1;
    }
  }
  
  CartObj.itemChangeQty(key, qty, $el);
}

var CartObj = {
  
  
  
  rebuildSuggested: function(){
    var suggested_products = $('.suggested-product-container');
    var current_products = [];
    $('[data-product-id]').each(function(){
      current_products.push($(this).data('product-id'));
    });

    var slick = suggested_products.slick('getSlick');
    var slickSlideCount = slick.slideCount;
	console.log('slidecount', slickSlideCount);
    suggested_products.slick('slickFilter', function(index, elem) {
      
      if(current_products.includes($(this).data('suggested-id')) && slickSlideCount  <= 3){
        console.log('hey2');
      	return true;
      }else if(!current_products.includes($(this).data('suggested-id'))){
        console.log('hey1');
       	return true; 
      }else{
        slickSlideCount--;
        return false;
      }
    });
    
  },
  
  itemChangeQty:function(key, qty, $el){
    $.ajax( {
      type: 'post',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        'quantity': qty,
        'id': key
      },
      success: function( cart ) {
        Shopify.getCart(function(cart){
          if(!$el.hasClass('quantity__input')){
            $el.siblings('input').val(qty);
          }else{
            $el.val(qty);
          }

          CartObj.updateTotal(cart);
          CartObj.changeCartCount(cart.item_count);
        });
      }
    });
  },
  
  addToCart: function(data) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: data,
      success: function(product){
        Shopify.getCart(function(cart){
          CartObj.addToCartOkay(cart);
        });
      },
      error: function(err){
        console.log(err);
      }
    });
  },
  
  openDrawer: function(){
    
    var $drawerWrapper = $('.drawer-wrapper');
    var $drawerMain = $drawerWrapper.find('.drawer-main');

    if(!$drawerWrapper.hasClass('open')){
      var intercom_container = $('.intercom-launcher, #intercom-container');
      //hide intercom icon
      intercom_container.hide();

      $drawerWrapper.removeClass('close');
      $('body , html').addClass('drawer-open');

      $drawerWrapper.addClass('open');
    }

    console.log($('.js-drawer-swatch-carousel'));
    console.log($('.js-drawer-recommendation-slider'));

    $('.js-drawer-recommendation-slider').slick('refresh');
    
    
    $('.suggested-product-container').slick('refresh');
  },

  closeDrawer: function(params){
    var $drawerWrapper = $('.drawer-wrapper');

      $('body , html').removeClass('drawer-open');



      $drawerWrapper.addClass('close');
      $drawerWrapper.removeClass('open');
  },
  
  updateTotal: function(cart){

    var automatic_discount_title = false;
    var subtotal = cart.total_price;
    var remove_discounts = 0;

    if(cart['cart_level_discount_applications'] !== undefined && cart['cart_level_discount_applications'] !== null){
      var cart_discounts = cart['cart_level_discount_applications'];
      for(var i = 0; i < cart_discounts.length; i++){
        if(cart_discounts[i].type == "automatic"){
          automatic_discount_title = cart_discounts[i].title;
          //compute new subtotal remove the discount from subscription products
          var items = cart.items;
          for(var j = 0; j < items.length; j++){
            if(theme.Drawer.checkSubscriptionProduct(items[j], true)){
              var discounts = items[j].discounts;
              for(var x = 0; x < discounts.length; x++){
                if(discounts[x].title == automatic_discount_title){
                  remove_discounts += discounts[x].amount;
                }
              }
            }
          }
          break;
        }
      }
    }

    subtotal = subtotal + remove_discounts;

    $('#drawer-subtotal-price').html(theme.Currency.formatMoney(subtotal, theme.moneyFormat));

    CartObj.updateFreeShippingBar(subtotal);
  
    $(document).trigger('drawercartpricechange', [subtotal]);
  },

  updateFreeShippingBar: function(total){
    const threshold = 20000;
    let freeShipText;
    let percent = "100%";
    if(total >= threshold){
      freeShipText = "You’ve earned free shipping, check out now!"
    }else{
      let difference = threshold - total;
      difference = theme.Currency.formatMoney(difference, theme.moneyFormat)
      freeShipText = `You're <span class="js-drawer-free-shipping-amount">${difference}</span> away from free shipping`; 
      percent = Math.round(total / threshold * 100) + '%';
    }

    $('.js-drawer-free-shipping-percent').text(percent);
    $('.js-drawer-free-shipping-progress').css('width', percent);
    $('.js-free-shipping-text').html(freeShipText);
    
  },


  cartChange: function(cart, product=false){


    if(cart == false){
      $.ajax({
        dataType: "json",
        url: '/cart.js',
        cache: false,
        success: function(newCart){
          CartObj.updateTotal(newCart);
          CartObj.changeCartCount(newCart.item_count);
          
        }
      });
    }else{
      //console.log(cart);
      CartObj.updateTotal(cart);
      CartObj.changeCartCount(cart.item_count);
      
    }
  },
  
  changeCartCount: function(cart_items){
    cart_items = parseInt(cart_items);
    if(cart_items > 0){
      $('#CartCount span').text( cart_items );
      $('#CartCount').show();
    }else{
      $('#CartCount').hide();
    }
  },
  
  cartReloadPageRefresh: function(showDrawer){
    $('#CartCount').hide();
    $.ajax({
      dataType: "json",
      url: '/cart.js',
      cache: false,
      success: function(newCart){
        //clear cart wrapper before appending items
        console.log('reload',newCart);


        $('.cart-item-wrapper').empty();
        for(var i = 0; i < newCart.items.length; i++){
          //console.log(newCart.items[i]);
          CartObj.addItemToDrawer(newCart.items[i]);
        }
        CartObj.updateTotal(newCart);
        CartObj.changeCartCount(newCart.item_count);
        
        if(showDrawer){
          CartObj.openDrawer();
        }
      }
    });



  },
  


  addItemToDrawer: function(product){
    var isSale = false;
      var $drawerWrapper = $('.drawer-wrapper');
      var $cartItemWrapper = $drawerWrapper.find('.cart-item-wrapper');


      var price = product.discounted_price;
    

      var title = product.product_title;
    title = title.split("-")[0];
    if(title == "THE BACKPACK"){
      title = "THE BACKPACK - NEW"
    }
      var url = product.url;
      var properties = "";
            // remove url query string
      url = url.split("?");
      url = url[0];
      var image = product.image;
      image = theme.Images.getSizedImageUrl(image, '200x200');
      var quantity = product.quantity;


      var compare_price = 0;
      var monogram = false;

      var uid = "";
      var monogram_note = "";
      var add_monogram_note = false;
      var other_note = "";
      var other_classes = "";

      if(compare_price > price){
        isSale = true;
      }

      price = theme.Currency.formatMoney(price, theme.moneyFormat);
      compare_price = theme.Currency.formatMoney(compare_price, theme.moneyFormat);
      var product_key = product.key;
      var variant = '';

      if(product.variant_title !== null){
        variant = product.variant_title;
      }
    
      var extra_note = "";
      // add note for sample sale
      if(product.product_type == "SAMPLE SALE"){
        extra_note = `<div class="cart__meta-text preorder-note sample-sale-warning" style="padding: 5px 0 5px;">
							FINAL SALE: No returns or exchanges
                        </div>`
      }
    
      for (var key in product.properties) {
          if (product.properties.hasOwnProperty(key)) {
            var value = product.properties[key];
            
            if(key == "_note" && value != ""){
              other_note = `<div class="cart__meta-text preorder-note" style="padding: 5px 0 5px;">
							` + value + `
                        </div>`;
            }
            if(key == "_uid" && value != ""){
              monogram = true;
              add_monogram_note = true;
              uid = value;
              other_classes += " monogram-remove";
            }
            
            if(key == "_isMonogram" && value == "YES"){
              add_monogram_note = true;
            }
            if(key != "Product" && value != "" && key.charAt(0) != "_"){
           	  properties += key + ": " + value +"<br>";
            }
          }
      }
    
    console.log(product);
    
   
    
      var quantity_element = `<div class="quantity-selector drawer-quantity-selector">
                                <span data-operation="minus" class="drawer-qty-adjust quantity__minus">
                                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/></svg>
                                </span>
                                <input type="text" class="js-qty__num quantity__input" value="`+ quantity +`" min="1" aria-label="quantity" pattern="[0-9]*" name="quantity">
                                <span data-opeation="plus" class="drawer-qty-adjust quantity__plus">
                                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg>
                                </span>
                              </div>`;
      
      if(monogram){
        quantity_element = `<div class="drawer-fixed-qty" style="font-style: italic">
                              Quantity: ` + quantity + `</div>`
        
      }
    
    if(add_monogram_note){
      monogram_note = `<div class="cart__meta-text red-note" style="padding: 5px 0 5px;">
                          <b>All personalized items are final sale + take 2 weeks to complete</b>
                        </div>`;
    }
    
    if(product.gift_card){
      variant = '';
    }

      console.log(product);

      var cart_item = `<div class="cart-item" data-id="`+ product_key +`">
        <div class="cart-item-image">
          <img src="`+ image + `">
        </div>
        <div class="cart-item-content">
          <h6 class="cart-item-title">
            <a href="` + url +`">
               `+ title +`
            </a>
          </h6>
          <div class="cart__meta-text property">
              `+ variant +`
         </div>
	     <div class="cart__meta-text property">
			  `+ properties +`
		 </div>
         <p class="product-grid-item-promo-text drawer-cart-promo-text"><span class="number">30%</span> OFF WITH CODE CYBERMONDAY</p>
         <div class="drawer-control-group">
        ` + quantity_element + `
            <p><span class="cart-item-price money">`+ price+`</span>
               <s class="cart_item product__price--strike hide" >` + compare_price +`</s>
           </p>
          </div>

          <p style="width: 100%; text-align: left; margin-bottom: 8px;" class="sale-offer drawer-cart-sale-offer number">
              <small><span class="number">5</span> DAYS OF MP GIFTING | DAY <span class="number">5/5</span> | SPEND $200, GET A FREE SILK SCARF</small>
            </p>
           
          `+monogram_note+`

		  `+other_note+`

		  `+extra_note+`


          <a class="cart-item-remove-container `+ other_classes + `" data-key="` + product_key +`" data-monogram="` + uid + `">
          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 20 20"><path fill="#444" d="M15.89 14.696l-4.734-4.734 4.717-4.717c.4-.4.37-1.085-.03-1.485s-1.085-.43-1.485-.03L9.641 8.447 4.97 3.776c-.4-.4-1.085-.37-1.485.03s-.43 1.085-.03 1.485l4.671 4.671-4.688 4.688c-.4.4-.37 1.085.03 1.485s1.085.43 1.485.03l4.688-4.687 4.734 4.734c.4.4 1.085.37 1.485-.03s.43-1.085.03-1.485z"/></svg>
          </a>
        </div>
      </div>`;

      var $cart_item = $(cart_item);
    if(isSale){
      $cart_item.find('.product__price--strike').removeClass('hide');
      $cart_item.find('.cart-item-price').addClass('product__price--sale');
    }

      $cartItemWrapper.prepend($cart_item);


  },

  addToCartOkay: function(product){
    //CartObj.checkPromoItem(cart);
    var $drawerWrapper = $('.drawer-wrapper');


    for(var i = 0; i < cart.items.length; i++){
      var product = cart.items[i];
      var itemFound = CartObj.checkDrawerItems(product);
      if( itemFound != false){
        var qty = product.quantity;
        var $cartItem = $drawerWrapper.find('[data-id="'+ itemFound +'"]');
        var $qtyContainer = $cartItem.find('.quantity__input');
        console.log($cartItem);
        $qtyContainer.val(qty);
      }else{
        CartObj.addItemToDrawer(product);
      }
       
    }

    CartObj.cartChange(false, product);
    CartObj.openDrawer();
    
  },

  checkPromoItem: function(cart){
    let isAdded = false;
    var id = 44856492228842;
    var limit = 1;
    var cart_length = cart.items.length;
    console.log(cart);
    var promo_item_key = false;
    for(var i = 0; i < cart_length; i++){
      var product = cart.items[i];
      if(product.id == id){
        isAdded = true;
        promo_item_key = product.key;
        if(product.quantity > limit){
          CartObj.setPromoItemToLimit(product.key, limit);
        }
        break;
      }
    }
    //removePromo Item
    let subtotal = cart.items_subtotal_price;
    let total_discount = subtotal * 0.3;
    let cart_total_discounted = subtotal - total_discount
    if(isAdded && cart_total_discounted < 20000){
      CartObj.removePromoItem(promo_item_key);
    }else if( !isAdded && cart_length > 0 && cart_total_discounted >= 20000){
      CartObj.addPromoItem();
    }
  },

  setPromoItemToLimit: function(key, limit){
    var data = {
      'id': key,
      'quantity': limit
    }

    Rebuy.Cart.changeItem(data);

  },
  removePromoItem: function(key){
    var id = 44856492228842
    var data = {
      'id': key,
      'quantity': 0
    }
    Rebuy.Cart.changeItem(data);
  },

  addPromoItem: function(){
    var id = 44856492228842;
    let data = {
      quantity: 1,
      id: id
    }
    Rebuy.Cart.addItem(data);
  },
  
  checkDrawerItems: function(product){
    var $drawerWrapper = $('.drawer-wrapper');
    var $drawerCartItems = $drawerWrapper.find('.cart-item');
    var itemFound = false;
    $drawerCartItems.each(function(){
      var id = $(this).data('id');
      var searchKey = product.key;
      console.log(searchKey);
      if( id == searchKey){
        itemFound = id;
      }
    });

    return itemFound;
  },
}
//rebuy event listener for promo


// document.addEventListener('rebuy:cart.change', (event) => { 
//   console.log('rebuy:cart.change event', event.detail.cart.cart); 
//   CartObj.checkPromoItem(event.detail.cart.cart);
// });




document.addEventListener('rebuy:cart.change', (event) => { 
  //console.log('rebuy:cart.change event', event.detail.cart.cart); 
  let cart = event.detail.cart.cart;
  $('.js-cart-count').text(cart.item_count);
});

